import { omit } from 'lodash';
import { graphql } from '@/gql';
import type { AddLovedOneMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { LovedOne } from '@/models/lovedOne';

export const addLovedOne = async ({ callerId, data }: AddLovedOneMutationVariables): Promise<LovedOne> => {
  const inputData = omit(data, ['phoneInfo', 'id']);

  const response = await mutationExecute({
    mutation: graphql(`
      mutation AddLovedOne($callerId: String, $data: LovedOneInputType!) {
        addLovedOne(callerId: $callerId, data: $data) {
          id
        }
      }
    `),
    variables: {
      callerId,
      data: inputData,
    },
  });

  return response.data?.addLovedOne!;
};
